import React, { Component } from 'react';
import './PrioritiesComponent.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';

class PrioritiesFutureComponent  extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            currentList: []
        };
    }

    componentWillMount(){
        
        //this.props.getInfluencerMapGroupsData.Items[0].groups
       
    }

    render() {
        
        let currentList =  _.map(this.props.getInfluencerMapGroupsData.Items[0].priorities.current, (value, index) =>{
            let item = this.props.getInfluencerMapGroupsData.Items[0].groups.find(r => r.groupId === value);
            return <p>{item.groupName ? item.groupName : ''}</p>
        })

        let futureList =  _.map(this.props.getInfluencerMapGroupsData.Items[0].priorities.future, (value, index) =>{
            let item = this.props.getInfluencerMapGroupsData.Items[0].groups.find(r => r.groupId === value);
            return <p>{item.groupName ? item.groupName : ''}</p>
        })

        return (
            <div className='select-menu-canvas influencer-map-form'>
                <div className='small-result-box success-data'>
                    <h4>Prior to this analysis</h4>
                    <p>{currentList}</p>
                </div>
                <div className='small-result-box success-data'>
                    <h4>After this analysis</h4>
                    <p>{futureList}</p>
                </div>

            </div>
            
        )
    }
}

export default (PrioritiesFutureComponent);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/Result/PrioritiesComponent/PrioritiesComponent.jsx